import axios from 'axios';

// Use the backend URL directly for website endpoints
// Remove /api from REACT_APP_API_URL since it's already included
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8080').replace(/\/api$/, '');

// Get all website enquiries with filters
export const getWebsiteEnquiries = async (params = {}, token) => {
  const headers = token ? { 'x-auth-token': token } : {};
  
  try {
    console.log('Fetching enquiries with token:', token ? 'Present' : 'Missing');
    console.log('Request URL:', `${API_URL}/api/website/enquiries`);
    console.log('Headers being sent:', JSON.stringify(headers));
    
    const response = await axios({
      method: 'get',
      url: `${API_URL}/api/website/enquiries`,
      params,
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching website enquiries:', error);
    console.error('Response status:', error.response?.status);
    console.error('Response data:', JSON.stringify(error.response?.data));
    console.error('Token that was used:', token);
    throw error;
  }
};

// Update enquiry status
export const updateEnquiryStatus = async (enquiryId, updateData, token) => {
  const headers = token ? { 'x-auth-token': token } : {};
  
  try {
    const response = await axios.put(
      `${API_URL}/api/website/enquiries/${enquiryId}`,
      updateData,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating enquiry status:', error);
    console.error('Token that was used:', token);
    throw error;
  }
};

// Export functions
export default {
  getWebsiteEnquiries,
  updateEnquiryStatus
};